import React from "react";
import { useTheme } from "styled-components";

const Overview = () => {
  const theme = useTheme();
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.594 2.25H3.656c-.362 0-.656.378-.656.844v5.062c0 .466.294.844.656.844h3.938c.362 0 .656-.378.656-.844V3.094c0-.466-.294-.844-.656-.844m7.5 0h-3.938c-.362 0-.656.21-.656.469V5.53c0 .26.294.469.656.469h3.938c.362 0 .656-.21.656-.469V2.72c0-.26-.294-.469-.656-.469m-7.5 8.999H3.656c-.362 0-.656.21-.656.469v2.812c0 .26.294.469.656.469h3.938c.362 0 .656-.21.656-.469V11.72c0-.26-.294-.469-.656-.469m7.5-3.001h-3.938c-.362 0-.656.378-.656.844v5.062c0 .466.294.844.656.844h3.938c.362 0 .656-.378.656-.844V9.094c0-.466-.294-.844-.656-.844"
        stroke={theme.text.text}
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Overview;
